// PathHealthChip — "¿el monitoreo de esta empresa depende de un túnel NUESTRO,
// y ese camino está sano?"
//
// WHY (Casa Superí, ago-2026): a la casa le cambió la IP pública y su túnel IPsec
// quedó enganchado a una conn equivocada. Figuraba ESTABLISHED pero el tráfico no
// pasaba, así que nuestros monitores la veían caerse y volver y el sistema le
// mandó al dueño ~7 mails en 11 días diciéndole "Posible corte de luz en tu casa".
// Nunca hubo corte de luz: era nuestro túnel. Andy no debería enterarse de esto
// leyendo logs — por eso el estado del camino se ve en la Ficha del cliente y en
// Casas Managed, al lado del resto del estado de la empresa.
//
// El chip NO se dibuja cuando la empresa no depende del túnel (sonda local dentro
// del LAN, o monitores públicos): ahí no hay camino nuestro que pueda fallar y un
// chip gris permanente sería ruido.
//
// La lógica vive en el backend (services/_alerting/pathHealth.js); acá sólo se
// pinta el veredicto que ya viene resuelto.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, ShieldAlert, HelpCircle } from 'lucide-react';

const BASE = {
  display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12,
  padding: '3px 10px', borderRadius: 999, fontWeight: 600,
};

export default function PathHealthChip({ path, style = {}, chipRef }) {
  const { t } = useTranslation();
  if (!path || !path.tunnelDependent) return null;

  const tunnels = (path.tunnels || []).join(', ');
  const evidence = (path.evidence || []).map((e) => e.detail).join('\n');
  const title = [path.reason, evidence].filter(Boolean).join('\n\n');

  if (path.verdict === 'our_path_suspect') {
    // Sospecha fuerte (hay un testigo fuera del túnel que nos desmiente) vs débil
    // (sólo correlación entre túneles). La débil NO retiene el mail al cliente,
    // así que tampoco se pinta igual de grave.
    const strong = path.confidence === 'high' || path.confidence === 'medium';
    return (
      <span
        ref={chipRef}
        title={title}
        style={{
          ...BASE,
          background: strong ? 'rgba(239,68,68,0.12)' : 'rgba(245,158,11,0.14)',
          color: strong ? '#ef4444' : '#d97706',
          ...style,
        }}
      >
        <ShieldAlert size={12} />
        {strong ? t('monitor.pathHealth.suspect') : t('monitor.pathHealth.maybe')}
      </span>
    );
  }

  if (path.verdict === 'unknown') {
    return (
      <span ref={chipRef} title={title} style={{ ...BASE, background: 'var(--c-surface-2)', color: 'var(--c-text-muted)', ...style }}>
        <HelpCircle size={12} /> {t('monitor.pathHealth.unverified')}
      </span>
    );
  }

  return (
    <span ref={chipRef} title={title} style={{ ...BASE, background: 'rgba(34,197,94,0.12)', color: '#16a34a', ...style }}>
      <Route size={12} /> {t('monitor.pathHealth.ok', { tunnel: tunnels || '—' })}
    </span>
  );
}
